import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
/** Read-only preview of the resolved SMS body with variable chips, char and segment counts. */
export function SmsComposePreview(_ref) {
  var text = _ref.text,
    segments = _ref.segments,
    tokens = _ref.tokens;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mb-1 text-style-label-strong text-sds-base-secondary"
  }, t("sms.compose.message_label", {
    defaultValue: "Message (from approved template · not editable here)"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 border border-sds-base-default bg-sds-base-secondary p-3 text-style-body-small text-sds-base-default"
  }, text || t("sms.compose.select_template_placeholder", {
    defaultValue: "Select a template…"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-style-label-base text-sds-base-tertiary"
  }, tokens.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "inline-flex flex-wrap items-center gap-1"
  }, tokens.map(function (token, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: token,
      className: "inline-flex items-center gap-1"
    }, /*#__PURE__*/React.createElement("code", {
      className: "rounded-sds-100 bg-sds-base-tertiary px-1.5 py-0.5 font-sds-medium text-sds-base-secondary"
    }, token), index < tokens.length - 1 ? /*#__PURE__*/React.createElement("span", {
      className: "text-sds-base-tertiary"
    }, t("sms.compose.token_and", {
      defaultValue: "&"
    })) : null);
  })), /*#__PURE__*/React.createElement("span", null, t("sms.compose.tokens_filled", {
    defaultValue: "filled from the patient record"
  })), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\xB7")) : null, /*#__PURE__*/React.createElement("span", null, t("sms.compose.approx_chars", {
    defaultValue: "≈ {{count}} chars",
    count: text.length
  })), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\xB7"), /*#__PURE__*/React.createElement("span", {
    className: "inline-flex items-center rounded-sds-full bg-sds-success-tertiary px-2 py-0.5 text-style-label-strong text-sds-success-default"
  }, t("sms.compose.approx_segments", {
    defaultValue: "≈ {{count}} segment(s)",
    count: segments
  })), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\xB7"), /*#__PURE__*/React.createElement("span", null, t("sms.compose.footer_appended", {
    defaultValue: "footer auto-appended"
  }))));
}